import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * Light/dark theming.
 *
 * `@atlas/design-tokens` defines both themes and `buildThemeCss()` emits them
 * under `:root` and `.dark`, so all that is left is putting the right class on
 * `<html>` — which is exactly `next-themes`' job. Despite the name it has no
 * Next.js dependency; it is used here for the parts that are genuinely fiddly:
 * following the OS preference, persisting an explicit choice, and applying the
 * class before first paint so the app never flashes light then snaps to dark.
 *
 * `disableTransitionOnChange` stops every surface cross-fading at once when the
 * theme flips, which in a tool full of screenshots reads as a glitch.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => (
  <NextThemesProvider
    attribute="class"
    defaultTheme="system"
    enableSystem
    disableTransitionOnChange
    storageKey="atlas-theme"
  >
    {children}
  </NextThemesProvider>
);
